import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mr0264',
    ecrans: ['00-2']
});
